import React from 'react';
import { useAppSelector } from '@app/hooks';
import { Pagination } from '@components/pagination';
import { selectModelsTotalCount } from '@modules/models-page';

export const ModelsPagePagination: React.FC = () => {
    const totalCount = useAppSelector(selectModelsTotalCount);
    return <Pagination totalCount={totalCount} wrap />;
};
